module.exports = __webpack_public_path__ + "fonts/312128_1_0.eot";